import AjaxClass from '@/ajax'

export default class GroupService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getList (then, params) {
    return this.ajax.get('/group', params, (data) => {
      return then(data)
    })
  }

  getItem (id, then, params) {
    return this.ajax.get('/group/' + id, params, (data) => {
      return then(data)
    })
  }

  saveItem (item, update, then) {
    return this.ajax.post('/group/save', {item: item, update: update}, (data) => {
      then(data)
    })
  }

  deleteItem (id, then) {
    return this.ajax.post('/group/delete', {id: id}, (data) => {
      then(data)
    })
  }

  isEditable (status) {
    return !['Закончена', 'В процессе'].includes(status)
  }

  static getDefaultItem () {
    return {
      id: 0,
      name: '',
      category: '',
      organization: {
        id: ''
      },
      attestationInfo: {
        status: '',
        date: ''
      },
      students: []
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/GroupService.js